import { render, staticRenderFns } from "./DItemSelector.vue?vue&type=template&id=4da7f223&"
import script from "./DItemSelector.vue?vue&type=script&lang=ts&"
export * from "./DItemSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DItemSelector.vue?vue&type=style&index=0&id=4da7f223&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports